import { Box, Heading } from "@chakra-ui/react";

export const NotFound = () => (
  <Box
    width="100%"
    height="100%"
    flex={1}
    alignItems="center"
    justifyContent="center"
    display="flex"
  >
    <Heading as="h1" textStyle="headingLg">
      Page Not Found
    </Heading>
  </Box>
);
